import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  Radio,
  DatePicker,
  Avatar,
  Modal,
  InputNumber,
  TimePicker,
} from "antd";
import moment from "moment";
import FromInput from "../../../../../components/user/from/Input";
import {
  changeFormatdate,
  changeFormatFulldate,
} from "../../../../../utils/formatdate";

import { numberWithCommas } from "../../../../../utils/number";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
  { label: "ใบรับรองแพทย์", value: "ใบรับรองแพทย์" },
  //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
  { label: "อื่น ๆ", value: "อื่น ๆ" },
];

const newsDataProfile = "";
const format = "HH:mm";

class Tab5 extends Component {
  state = {
    dataTalbeUploads: [
      {
        documentType: null,
        description: null,
        attachFile: null,
        statusFile: false,
      },
    ],
    columns: [
      {
        title: "ปีการศึกษา",
        dataIndex: "studyEducationFeeYear",
        align: "center",
        vertical: "top",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyEducationFee[index]
                ?.studyEducationFeeYear ? (
                <Form.Item label={""} style={{ marginBottom: "0px" }}>
                  <Select
                    style={{ width: "100%" }}
                    value={
                      parseInt(
                        this.props.detailForm?.studyEducationFee[index]
                          ?.studyEducationFeeYear
                      )
                    }
                    disabled={true}
                  ></Select>
                </Form.Item>
              ) : (
                ""
              )} */}
                {item ? item :"-"}
            </>
          );
        },
      },
      {
        title: "ภาคการศึกษาที่",
        dataIndex: "studyEducationFeeTerm",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyEducationFee[index]
                ?.studyEducationFeeTerm ? (
                <FromInput
                  disabled={true}
                  value={
                    this.props.detailForm?.studyEducationFee[index]
                      ?.studyEducationFeeTerm
                  }
                  required={false}
                  name={"name"}
                  mode={"text"}
                />
              ) : (
                ""
              )} */}
              {item ? item : "-"}
            </>
          );
        },
      },
      // {
      //   title: "จำนวนเงินที่ขอเบิก (บาท)",
      //   dataIndex: "studyEducationPrice",
      //   width: "200px",
      //   vertical: "top",
      //   align: "center",
      //   render: (item, record, index) => {
      //     return (
      //       <>
      //         {/* {this.props.detailForm?.studyEducationFee[index]
      //           ?.studyEducationPrice ? (
      //           <InputNumber
      //           step={1000.01}
      //           min={0.0}
      //           disabled={true}
      //           formatter={(item) =>
      //             `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      //           }
      //           style={{marginTop:"3px"}}
      //           parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
      //           value={this.props.detailForm?.studyEducationFee[index]?.studyEducationPrice}
      //           className="input-number"
      //         />
      //         ) : (
      //           "-"
      //         )} */}
      //          {numberWithCommas(item)}
      //       </>
      //     );
      //   },
      // },
      {
        title: "จำนวนเงินที่เบิกได้จริง (บาท)",
        dataIndex: "studyEducationActualPrice",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyEducationFee[index]
                ?.studyEducationActualPrice ? (
                <InputNumber
                step={1000.01}
                min={0.0}
                disabled={true}
                formatter={(item) =>
                  `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                style={{marginTop:"3px"}}
                parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                value={this.props.detailForm?.studyEducationFee[index]?.studyEducationActualPrice}
                className="input-number"
              />
              ) : (
                "-"
              )} */}
             {item ? numberWithCommas(item) : "-"}
            </>
          );
        },
      },
      {
        title: "วันที่จ่าย",
        dataIndex: "studyEducationPaidDate",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyEducationFee[index]
                ?.studyEducationPaidDate
                ? changeFormatFulldate(
                    this.props.detailForm?.studyEducationFee[index]
                      ?.studyEducationPaidDate
                  )
                : "-"} */}
{item ? changeFormatFulldate(item) : "-"}
            </>
          );
        },
      },
      {
        title: "สถานะเอกสาร",
        dataIndex: "studyEducationFeeStatusName",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyEducationFee[index]
                ?.studyEducationFeeStatusName
                ? this.props.detailForm?.studyEducationFee[index]
                    ?.studyEducationFeeStatusName
                : ""} */}
                {item ? item : "-"}
            </>
          );
        },
      },
      {
        title: "หมายเหตุ",
        dataIndex: "studyEducationRemark",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyEducationFee[index]
                ?.studyEducationRemark ? (
                <FromInput
                  disabled={true}
                  value={
                    this.props.detailForm?.studyEducationFee[index]
                      ?.studyEducationRemark
                  }
                  required={false}
                  name={"name"}
                  mode={"text"}
                />
              ) : (
                "-"
              )} */}
              {item ? item : "-"}
            </>
          );
        },
      },
    ],
    dataTalbeLength: 1,
    preLoadOnsubmit: false,
  };

  showDetailBtnInput = (record, arrayId) => {
    const { dataTalbeUploads } = this.state;
    return (
      <>
        {dataTalbeUploads.length > 1 ? (
          <Avatar
            shape="square"
            icon={<Icon type="delete" />}
            className="mr-1 mb-1 bg-red"
            // onClick={ () => this.destroyArrayDataUploads(arrayId) }
            style={{ cursor: "pointer", background: "red" }}
          />
        ) : (
          <Avatar
            shape="square"
            icon={<Icon type="delete" />}
            className="mr-1 mb-1 bg-red"
            // onClick={ () => this.destroyArrayDataUploads(arrayId) }
            style={{ cursor: "not-allowed" }}
            disabled={true}
          />
        )}
      </>
    );
  };


  render() {
    const { match, detailForm, dataTermfeeHistory } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { columns, preLoadOnsubmit, dataTalbeUploads } = this.state;

    // console.log('dataTalbeUploads',leaveDayAllData)

    return (
      <Row gutter={16} type="flex" justify="left" align="top">
        <Col xs={24} md={24} className="pt-0">
          <strong className="color-red">การเบิกค่าธรรมเนียมการศึกษา</strong>
        </Col>

        <Col xs={24} md={24} align={"right"} className="pt-4">
          <Table
            columns={columns}
            dataSource={detailForm?.studyEducationFee}
            pagination={false}
            className="mb-3"
            bordered
            rowCount={detailForm?.studyEducationFee.length}
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            scroll={{ x: "max-content" }}
            // pagination={{ pageSize: dataTalbeUploads.length }}
          />
          <Col span={24} className="flex-end align-center">
                    <span>{`จำนวนเงินที่ใช้ไป : `}</span>
                    <span style={{ width: 123, textAlign: "right" }}>
                      {`${numberWithCommas(dataTermfeeHistory?.totalPaid || 0)} บาท`}
                    </span>
                  </Col>
                  <Col span={24} className="flex-end align-center">
                    <span>{`จำนวนเงินคงเหลือที่เบิกได้ : `}</span>
                    <span style={{ width: 123, textAlign: "right" }}>
                      {`${numberWithCommas(dataTermfeeHistory?.totalBalance || 0)} บาท`}
                    </span>
                  </Col>
        </Col>
      </Row>
    );
  }
}

Tab5.defaultProps = {
  autoFocus: false,
};
Tab5.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedTab5 = Form.create()(Tab5);

export default withApollo(WrappedTab5);
